// tslint:disable:no-any
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { loadSharedDives } from '../actions/diveActions';
import DivesFilterYears from '../components/DivesFilterYears';
import DivesTable from '../components/DivesTable';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Title from '../components/Title';
import Dt from 'react-document-title';
import { NavigationStore } from './Navigation/NavigationStore';

export interface ISharedDivesProps {
    location: any;
    loadSharedDives: () => void;
    dives: any;
    viewDetail: any;
}

interface ISharedDivesState {
    message: any;
    year: any;
    messageType: any;
}

class SharedDives extends Component<ISharedDivesProps, ISharedDivesState> {
    constructor(props: ISharedDivesProps) {
        super(props);

        this.state = {
            year: null,
            message: null,
            messageType: null
        };
    }

    componentDidMount() {
        this.refreshDives();

        window.scrollTo(0, 0);

        NavigationStore.getInstance().setActive('dives');

        // message
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.message &&
            this.props.location.state.messageExpirate
        ) {
            if (this.props.location.state.messageExpirate > new Date()) {
                this.setState({
                    message: this.props.location.state.message,
                    messageType: this.props.location.state.messageType
                });
            }
        }
    }

    refreshDives() {
        this.props.loadSharedDives();
    }

    getTitle() {
        return 'WetNotes | Shared dives';
    }

    onCloseMessage() {
        this.setState({
            message: null,
            messageType: null
        });
    }

    onYearSet(year: number) {
        this.setState({
            year: year
        });
    }

    render() {
        const { dives, viewDetail } = this.props;

        if (dives.sharedDives === undefined) {
            return <Loader />;
        }

        return (
            <Dt title={this.getTitle()}>
                <div className="dives">
                    <Title
                        heading={'Shared Dives'}
                        breadcrumbs={[
                            { caption: 'Shared Dives', to: '/app/shared-dives' }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="col__sidebar">
                            <DivesFilterYears
                                dives={dives.sharedDives}
                                onYearSet={year => this.onYearSet(year)}
                            />
                        </div>

                        <div className="col__main">
                            {this.state.message !== null && (
                                <div className="messages">
                                    <Message
                                        type={this.state.messageType}
                                        text={this.state.message}
                                        autoClose={true}
                                        onClose={() => this.onCloseMessage()}
                                    />
                                </div>
                            )}

                            <DivesTable
                                title="Shared Dives"
                                shared={true}
                                year={this.state.year}
                                dives={dives.sharedDives}
                                viewDetail={viewDetail}
                                refreshDives={() => this.refreshDives()}
                            />
                        </div>
                    </div>
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dives: state.sharedDives.items || []
});

const mapDispatchToProps = (dispatch: any) => ({
    loadSharedDives: () => dispatch(loadSharedDives()),
    viewDetail: (index: any) => dispatch(push(`/app/shared-dive/${index}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(SharedDives);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SharedDives.tsx